module.exports = __webpack_public_path__ + "img/3.0455b2cd.jpg";